<template>
  <div class="app-main__inner">
    <TituloComponente
      icono-titulo="fas fa-clipboard-list"
      texto-titulo="Listado de personas"
      :to-create-action="{name:'NuevaPersona'}"
      to-create-text="Nueva persona"
    />
    <div class="tab-content">
      <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
        <div class="row">
          <div class="col-lg-12">
            <div class="main-card mb-3 card">
              <div class="card-body">
                <DataList
                  ref="datatable"
                  url="/personas"
                  :fields="fields"
                  :toCuil="toCuil"
                  :rowClick="verPersona"
                ></DataList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarPersonas",
  components: {
    TituloComponente,
    DataList,
  },
  data() {
    return {
      fields: [
        {
          name: "apellido",
          label: "",
          type: "title",
          class: "text-alternate",
        },
        {
          name: "nombre",
          label: "",
          type: "title",
          class: "text-alternate",
        },
        {
          name: "cuil",
          label: "CUIL",
          type: "field",
          class: "",
        },
        {
          name: "numero_afiliado",
          label: "N° afiliado",
          type: "field",
          class: "",
        },
      ],
      toCuil:['cuil']
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    verPersona(persona){
      this.$router.push({name:"VerPersona", params:{id:persona.id}})
    },
  },
};
</script>
